import React from 'react';
import classNames from 'classnames';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';
import ApexFundingAccountVerificationActivationTemplate
  from 'Views/Page/Content/Templates/ApexFundingAccountVerificationTemplate/ApexFundingAccountVerificationActivationTest/ApexFundingAccountVerificationActivationTemplate';

const useStyles = buildUseStyles('ApexFundingAccountVerificationActivationTest', (() => ({
  root: {},
})));

const ApexFundingAccountVerificationActivationTest = ({ className, resource }) => {
  const classes = useStyles();
  return (
    <WizardStepWrapperTemplate
      className={classNames(className, classes.root)}
      layout={ApexFundingAccountVerificationActivationTemplate}
      LayoutProps={{
        resource,
      }}
      resource={resource}
      metaOverrideSet={BaseOverrideNoHidden}
      disableNextButton
    />
  );
};

ApexFundingAccountVerificationActivationTest.defaultProps = {
  className: '',
};

ApexFundingAccountVerificationActivationTest.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.string.isRequired,
};

export default ApexFundingAccountVerificationActivationTest;
